module.exports = __webpack_public_path__ + "img/city (5).2e618751.png";